<template>
  <v-inventory-create
    v-if="access.create_purchase"
    name="purchase"
    ref="purchase"
    v-bind:total="total"
    top_title="create_purchase"
    :noAdditionalCost="
      params.type === 'refund' || purchase_type == 'upload_file'
    "
    @set-total-amount-currency="setTotalAmountCurrency"
    :noPartiation="true"
  >
    <v-radio-group v-if="purchase_type === 'items'" row v-model="params.type">
      <v-radio :label="$t('coming')" value="coming" />
      <v-radio :label="$t('refund')" value="refund" />
      <v-spacer />
      <v-switch label="SMS" v-model="params.send_message_to_supplier" />
    </v-radio-group>
    <v-layout row class="px-2">
      <v-flex class="px-1">
        <v-autocomplete
          v-model="params.supplier_id"
          :label="$t('supplier')"
          v-bind:items="suppliers"
          item-value="_id"
          item-text="supplier_name"
          ref="supplier"
          :rules="[fieldRules.required]"
        />
      </v-flex>
      <v-flex class="px-1">
        <v-autocomplete
          v-model="params.supplier_contract"
          :label="$t('supplier_contract')"
          v-bind:items="supplierContracts"
          item-value="value"
          item-text="label"
          ref="supplier_contract"
          :rules="[(value) => validateSupplierContract(value)]"
        />
      </v-flex>
      <v-flex class="px-1">
        <v-autocomplete
          v-model="params.service"
          :label="$t('store')"
          v-bind:items="stores"
          item-text="name"
          item-value="_id"
          ref="service"
          :rules="[fieldRules.required]"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="px-1" md6 sm12>
        <v-datetime-picker
          v-model="params.purchase_order_date"
          :label="$t('purchase_order_date')"
        />
      </v-flex>
      <v-flex class="px-1" md6 sm12>
        <v-datetime-picker
          v-if="params.type == 'coming' && params.refund === 'refund'"
          v-model="params.expected_on"
          :label="$t('expected_on')"
          v-bind:min="params.purchase_order_date"
        />
      </v-flex>
    </v-layout>

    <template #add_items_by_supplier>
      <v-flex md2 px-3 mt-3>
        <v-autocomplete
          v-if="params.type === 'coming'"
          v-model="purchase_type"
          :items="[
            {
              text: $t('items'),
              value: 'items',
            },
            {
              text: $t('upload_file'),
              value: 'upload_file',
            },
            {
              text: $t('by_receipt'),
              value: 'by_receipt',
            },
            {
              text: $t('by_tech_map'),
              value: 'by_tech_map',
            },
          ]"
        />
      </v-flex>
      <v-btn
        v-if="purchase_type === 'items' && params.type === 'coming'"
        color="primary"
        text
        @click="fillSoldItems"
      >
        {{ $t("fill_sold") }}
      </v-btn>
      <v-menu v-if="purchase_type === 'items' && params.type === 'coming'" left>
        <template #activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on" text>
            AutoFill
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list :disabled="params.supplier_id == null">
          <v-list-item
            @click="addBySupplier(1)"
            :disabled="params.supplier_id == null"
          >
            <v-list-item-title>{{
              $t("all_items_from_the_supplier")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="addBySupplier(2)"
            :disabled="params.supplier_id == null"
          >
            <v-list-item-title>{{
              $t("low_stock_items_from_the_supplier")
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <br />

    <template #items>
      <v-data-table
        v-if="purchase_type === 'items' || purchase_type === 'by_tech_map'"
        v-bind:headers="headers"
        disable-sort
        v-bind:items="items"
        :items-per-page="1000"
        hide-default-footer
        :mobile-breakpoint="0"
        :no-data-text="$t('you_have_not_selected_items_yet')"
        :loading="loadingItems"
      >
        <template #[`item.product_name`]="{ item }">
          <v-list-item-content
            style="
              width: 350px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            <v-list-item-title>{{ item.product_name }}</v-list-item-title>
            <v-list-item-subtitle>SKU {{ item.sku }}</v-list-item-subtitle>
            <v-list-item-subtitle
              v-if="item.barcode && item.barcode.length > 0"
            >
              Barcode
              <span v-for="(barcode, ind) in item.barcode" :key="ind">
                {{ barcode + ", " }}
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <!-- <template #[`item.mxik`]="{ item }">
          <v-text-field
            v-model.number="item.mxik"
            type="number"
            :ref="'mxik' + item._id"
            :rules="[fieldRules.require]"
            @focus="$event.target.select()"
          />
        </template>
        <template #[`item.nds_value`]="{ item }">
          <v-text-field
            v-model.number="item.nds_value"
            type="number"
            :ref="'nds_value' + item._id"
            :rules="[fieldRules.require]"
            suffix="%"
            @focus="$event.target.select()"
          />
        </template> -->
        <template #[`item.quality`]="{ item }">
          <v-text-field
            v-model.number="item.quality"
            type="number"
            :ref="'quality' + item._id"
            :rules="[fieldRules.require]"
            @focus="$event.target.select()"
          />
        </template>

        <template #[`item.purchase_cost`]="{ item }">
          <vuetify-money
            v-model="item.purchase_cost"
            :ref="'purchase_cost' + item.product_id"
            :rules="[fieldRules.require]"
            v-bind:options="
              item.purchase_cost_currency == 'uzs'
                ? moneyOptions
                : moneyOptionsUSD
            "
          />
        </template>
        <template #[`item.amount`]="{ item }">
          {{
            item.quality * item.purchase_cost
              ? (item.quality * item.purchase_cost).toLocaleString()
              : "-"
          }}
          <v-menu
            :value="item.number == clicked_index && item.quality"
            offset-x
            offset-y
            :close-on-click="false"
            :close-on-content-click="false"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                color="primary"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openMenu(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <v-card tile class="ma-0 pa-0">
              <v-card-text>
                <vuetify-money
                  v-model="changed_amount"
                  :label="$t('amount')"
                  :rules="[fieldRules.require]"
                  v-bind:options="
                    item.purchase_cost_currency == 'uzs'
                      ? moneyOptions
                      : moneyOptionsUSD
                  "
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text @click="clicked_index = null">
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn text color="primary" @click="saveChangeAmount">
                  {{ $t("ok") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </template>
        <template #[`item.remove`]="{ item }">
          <v-btn icon v-on:click="remove_item(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <v-divider />
      <v-card-text v-if="purchase_type == 'items'">
        <v-search-items
          v-bind:label="$t('add_item')"
          v-bind:items="items_list"
          v-bind:selectedAct="add_item"
          v-bind:rules="items && items.length == 0 ? [fieldRules.required] : []"
          v-bind:searchItems="getPurchaseItems"
          ><v-spacer />
          <!-- <template #nodata>
            <b v-if="create_new_item" class="ml-9">no data available </b>
            <v-btn
              v-if="create_new_item"
              class="pl-5 ml-4"
              outlined
              text
              @click="newCreateItem"
              :loading="loadingItemCreate"
              >{{ $t("new_item_create") }}</v-btn
            >
          </template> -->
        </v-search-items>
      </v-card-text>
      <v-card-text v-else-if="purchase_type == 'upload_file'">
        <div v-for="(err, ind) in upload_errors" :key="ind">
          <p class="red--text" style="font-size: 25px">
            {{ err.place ? err.place : "" }}
          </p>
          <p class="grey--text">{{ err.Error ? err.Error : "" }}</p>
          <v-divider />
        </div>
        <v-file-input
          v-model="items_file"
          accept="text/csv"
          :label="$t('items_file')"
        />
      </v-card-text>
      <v-card-text v-else-if="purchase_type == 'by_receipt'">
        <v-data-table
          v-if="receipts.length > 0"
          :items-per-page="1000"
          :items="receipts"
          :headers="receipts_headers"
          hide-default-footer
          disable-sort
        >
          <template #[`item.date`]="{ item }">
            {{ date_ddmmyy_hhmm(item.date) }}
          </template>
          <template #[`item.total_price`]="{ item }">
            {{
              item.total_price
                ? item.total_price.toLocaleString()
                : item.total_price
            }}
          </template>
          <template #[`item.remove`]="{ item }">
            <v-btn icon v-on:click="removeReceipt(item._id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-text-field
          v-model="receipt_id"
          @change="addReceipt"
          :label="$t('receipt_id')"
        />
      </v-card-text>
      <v-card-text v-else-if="purchase_type == 'by_tech_map'">
        <v-layout mx-2>
          <v-flex md8 px-2>
            <v-autocomplete
              v-model="tech_map_id"
              :label="$t('tech_map_item')"
              hide-no-data
              v-bind:items="tech_maps"
              item-text="product_name"
              item-value="_id"
              v-on:update:search-input="searchTechMaps"
            />
          </v-flex>
          <v-flex md4 px-2>
            <v-text-field
              v-model.number="order_item_count"
              type="number"
              :label="$t('count')"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </template>

    <template #action>
      <v-btn v-on:click="cancel" text>{{ $t("cancel") }}</v-btn>
      <v-btn
        v-if="target == 'create' && params.type == 'coming'"
        color="success"
        text
        v-on:click="save"
        :loading="saving_document"
        :disabled="saveDisabled || isoffline"
        >{{ $t(target) }}
      </v-btn>
      <v-btn
        color="success"
        text
        v-on:click="save('closed')"
        :loading="saving_document"
        :disabled="saveDisabled || isoffline"
        >{{ $t("create_and_receive") }}</v-btn
      >
    </template>

    <v-dialog v-model="exist_dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text">
          This item has already been added to this purchase order.
          <br />Do you want to add new line anyway?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="exist_dialog = false">Cancel</v-btn>
          <v-btn text @click="addItem">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-inventory-create>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import Currency from "../../mixins/settings/currency";
import TechMap from "../../mixins/items/tech_map";
export default {
  name: "PurchaseCreate",
  mixins: [Services, Currency, TechMap],
  data: () => ({
    purchase_type: "items",
    items: [],
    menus: [],
    temp_items: [],
    items_list: [],
    item: null,
    suppliers: [],
    defaultSupplierContracts: { value: null, label: 'No contract' },
    supplierContracts: [{ value: null, label: 'No contract' }],
    params: {
      type: "coming",
      refund: "refund",
      supplier_id: null,
      supplier_contract: null,
      purchase_order_date: new Date().toISOString().substr(0, 10),
      expected_on: new Date().toISOString().substr(0, 10),
      service: null,
      total_currency: "uzs",
      send_message_to_supplier: false,
    },
    search_text: "123",
    noAllStores: true,
    exist_dialog: false,
    exist_item: null,
    access: null,
    items_file: null,
    receipt_id: "",
    receipts: [],
    upload_errors: [],
    loadingItems: false,
    saving_document: false,
    order_item_count: 1,
    tech_map_id: null,
    tech_map_search: "123",
    itemTechMap: {},
    clicked_index: null,
    changed_amount: null,
    create_new_item: false,
    isoffline: false,
    loadingItemCreate: false,
    newItemParams: {
      barcode: [],
      sku: null,
      category: "",
      category_name: "Other",
      name: "New product",
    },
  }),
  computed: {
    receipts_headers() {
      return [
        {
          text: this.$t("receipt_no"),
          value: "receipt_no",
        },
        {
          text: this.$t("date"),
          value: "date",
          align: "center",
        },
        {
          text: this.$t("total"),
          value: "total_price",
          align: "right",
        },
        { text: null, value: "remove", align: "center", width: 50 },
      ];
    },
    headers() {
      let headers = [
        { text: "№", value: "number", width: 10 },
        { text: this.$t("item"), value: "product_name" },
        {
          text: this.$t("sold"),
          value: "sold",
          width: 80,
          align: "right",
        },
        {
          text: this.$t("last_come"),
          value: "last_come",
          width: 90,
          align: "right",
        },
        // {
        //   text: this.$t("mxik"),
        //   value: "mxik",
        //   width: 195,
        //   align: "right",
        // },
        // {
        //   text: this.$t("nds"),
        //   value: "nds_value",
        //   width: 80,
        //   align: "right",
        // },
        {
          text: this.$t("in_stock"),
          value: "in_stock",
          width: 90,
          align: "right",
        },
        {
          text: this.$t("quantity"),
          value: "quality",
          width: 90,
          align: "right",
        },
        {
          text: this.$t("purchase_cost"),
          value: "purchase_cost",
          width: 100,
          align: "right",
        },
        {
          text: this.$t("amount"),
          value: "amount",
          width: 150,
          align: "right",
        },
      ];
      // if (this.access && this.access.inv_purchase_orders_cost) {
      //   headers.push({
      //     text: this.$t("purchase_cost"),
      //     value: "purchase_cost",
      //     width: 100,
      //     align: "right",
      //   });
      //   headers.push({
      //     text: this.$t("amount"),
      //     value: "amount",
      //     width: 150,
      //     align: "right",
      //   });
      // }
      headers.push({ text: null, value: "remove", align: "center", width: 50 });
      return headers;
    },
    target() {
      return this.$route.params["target"];
    },
    total() {
      var sum = 0;
      if (this.purchase_type == "items") {
        for (const index in this.items) {
          let purchase_cost = this.items[index].purchase_cost;
          if (
            purchase_cost &&
            this.currency &&
            this.currency.value &&
            this.items[index].purchase_cost_currency == "usd"
          ) {
            purchase_cost = purchase_cost * this.currency.value;
          }
          sum += this.items[index].quality * purchase_cost;
        }
      } else if (this.purchase_type == "by_receipt") {
        for (const r of this.receipts) {
          sum += r.total_price;
        }
      }
      if (
        this.purchase_type != "upload_file" &&
        this.$refs["purchase"] &&
        this.$refs["purchase"].options() &&
        this.$refs["purchase"].options().additional_cost instanceof Array
      ) {
        for (const add_cost of this.$refs["purchase"].options()
          .additional_cost) {
          if (add_cost.amount && typeof add_cost.amount == typeof 5) {
            let amount = add_cost.amount;
            if (
              this.currency &&
              this.currency.value &&
              add_cost.amount_currency == "usd"
            ) {
              amount = amount * this.currency.value;
            }
            sum += amount;
          }
        }
      }
      if (
        this.params.total_currency == "usd" &&
        this.currency &&
        this.currency.value
      ) {
        sum = sum / this.currency.value;
      }
      // if (!(this.access && this.access.inv_purchase_orders_cost)) {
      //   sum = 0;
      // }
      return sum;
    },
    form() {
      const fObj = {
        supplier: this.params.supplier_id,
        service: this.params.service,
      };
      if (this.purchase_type == "items") {
        for (let i = 0; i < this.items.length; i++) {
          fObj["quality" + this.items[i]._id] = this.items[i].quality;
          // fObj["nds_value" + this.items[i]._id] = this.items[i].nds_value;
          // fObj["mxik" + this.items[i]._id] = this.items[i].mxik;
          // if (this.user_access && this.user_access.inv_purchase_orders_cost) {
          //   fObj["purchase_cost" + this.items[i]] = this.items[i].purchase_cost;
          // }
        }
      }
      if (
        this.purchase_type == "items" &&
        this.$refs["purchase"] &&
        this.$refs["purchase"].options() &&
        typeof this.$refs["purchase"].options().additional_cost == typeof []
      ) {
        for (
          let i = 0;
          i < this.$refs["purchase"].options().additional_cost.length;
          i++
        ) {
          fObj["additional_cost_name" + (i + 1)] =
            this.$refs["purchase"].options().additional_cost[i].name;
          // if (this.user_access && this.user_access.inv_purchase_orders_cost) {
          //   fObj["additional_cost_amount" + (i + 1)] =
          //     this.$refs["purchase"].options().additional_cost[i].amount;
          // }
        }
      }
      return fObj;
    },
    saveDisabled() {
      let formHasErrors =
        false ||
        (this.items.length == 0 && this.purchase_type == "items") ||
        (this.purchase_type == "upload_file" && this.items_file == null) ||
        (this.purchase_type == "by_receipt" && this.receipts.length == 0);
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f] && this.form[f] != 0) {
          formHasErrors = true;
        }
      });

      return formHasErrors || !this.validateSupplierContract(this.params.supplier_contract);
    },
  },
  watch: {
    "params.service"() {
      this.getPurchaseItems(this.search_text, true);
      this.itemsRefresh();
    },
    "params.supplier_id": {
      deep: true,
      handler() {
        this.params.supplier_contract = null;
        if(!this.params.supplier_id) {
          this.supplierContracts = [this.defaultSupplierContracts]
          return;
        }

        const supplier = this.suppliers.find(supplier =>supplier._id === this.params.supplier_id);
        if(Array.isArray(supplier.contract_numbers) && supplier.contract_numbers.length > 0) {
          this.supplierContracts = supplier.contract_numbers
            .map(contract_number => ({ value: contract_number, label: contract_number }))
          return;
        }

        this.supplierContracts = [this.defaultSupplierContracts]
      },
    },
    stores() {
      if (this.stores && this.stores.length > 0) {
        this.params.service = this.stores[0]._id;
      }
    },
    purchase_type() {
      if (this.purchase_type) {
        this.params.type = "coming";
        this.params.refund = "refund";
      }
    },
    items_file() {
      if (!this.items_file) {
        this.upload_errors = [];
      }
    },
    async tech_map_id() {
      await this.getByIdTechMap(false, this.params.service);
      const items = this.tech_map.composite_items;
      const itemTechMap = {};
      for (const index in items) {
        itemTechMap[items[index].product_id] = +items[index].quality + 0;
        items[index].number = +index + 1;
        items[index].purchase_cost = items[index].cost;
      }
      this.items = items;
      this.temp_items = JSON.parse(JSON.stringify(items));
      this.itemTechMap = itemTechMap;
    },
    order_item_count() {
      if (typeof this.order_item_count === "number") {
        const items = [];
        for (const index in this.temp_items) {
          if (this.itemTechMap[this.temp_items[index].product_id]) {
            const quality =
              this.itemTechMap[this.temp_items[index].product_id] *
                this.order_item_count -
              this.temp_items[index].in_stock;
            if (quality > 0) {
              items.push({
                ...this.temp_items[index],
                quality: quality,
              });
            }
          }
        }
        this.items = items;
      }
    },
  },
  methods: {
    async newCreateItem() {
      this.loadingItemCreate = true;
      this.newItemParams.barcode[0] = this.search_text;
      const result = this.$communicator.then(
        this,
        await this.$communicator("get_available_sku")
      );
      if (result) {
        this.newItemParams.sku = result.sku;
      }
      const itemget = await this.$communicator("create_item", {
        params: this.newItemParams,
      });
      if (itemget) {
        this.loadingItemCreate = false;
        const item = {
          product_id: itemget?.data?.data._id,
          product_name: itemget?.data?.data.name,
          purchase_cost: itemget?.data?.data.cost,
          sku: itemget?.data?.data.sku,
          purchase_cost_currency: "uzs",
        };
        this.add_item(item);
      }
      this.search_text = "";
      this.create_new_item = false;
      // const routeData = this.$router.resolve({ path: "/items/list/create" });
      // window.open(routeData.href, "_blank");
    },
    openMenu(item) {
      this.clicked_index = item.number;
      if (item.quality * item.purchase_cost) {
        this.changed_amount = item.quality * item.purchase_cost;
      } else {
        this.changed_amount = null;
      }
    },
    saveChangeAmount() {
      this.items.map((item) => {
        if (item.number == this.clicked_index && item.quality) {
          item.purchase_cost = this.changed_amount / item.quality;
        }
      });
      this.clicked_index = null;
    },
    async fillSoldItems() {
      this.loadingItems = true;
      const ids = [];
      for (const itm of this.items) {
        ids.push(itm.product_id);
      }
      const items = this.$communicator.then(
        this,
        await this.$communicator("inv_items_fill_sold", {
          params: {
            service: this.params.service,
            indexes: ids,
          },
        })
      );
      this.loadingItems = false;
      if (items instanceof Array) {
        const itemsMap = {};
        for (const itm of items) {
          itemsMap[itm.product_id] = itm;
        }
        for (const index in this.items) {
          if (itemsMap[this.items[index].product_id]) {
            this.items[index].sold =
              itemsMap[this.items[index].product_id].items_sold;
            this.items[index].last_come =
              itemsMap[this.items[index].product_id].items_received;
          }
        }
      }
    },
    setTotalAmountCurrency(currency) {
      this.params.total_currency = currency;
    },
    async addReceipt() {
      if (
        !(
          typeof this.receipt_id == typeof "invan" &&
          this.receipt_id.length == 24
        )
      ) {
        return;
      }
      let exist = false;
      for (const r of this.receipts) {
        exist = exist || r._id == this.receipt_id;
      }
      if (exist) {
        this.receipt_id = "";
        return;
      }
      const res = this.$communicator.then(
        this,
        await this.$communicator("receipt_by_id", {
          arguments: [this.receipt_id],
        })
      );
      if (res) {
        this.receipts.push(res);
        this.receipt_id = "";
      }
    },
    removeReceipt(id) {
      if (!(this.receipts instanceof Array)) {
        this.receipts = [];
      }
      const receipts = [];
      for (const r of this.receipts) {
        if (r._id != id) {
          receipts.push(r);
        }
      }
      this.receipts = receipts;
    },
    add_item(item) {
      let exist = false;
      for (const itm of this.items) {
        if (itm.product_id == item.product_id) {
          exist = true;
        }
      }
      if (exist) {
        this.exist_item = item;
        this.exist_dialog = true;
      } else {
        this.items.push({
          ...this.$copy(item),
          number: this.items.length + 1,
          quality: 1,
        });
      }
    },
    addItem() {
      this.items.push({
        ...this.$copy(this.exist_item),
        number: this.items.length + 1,
        quality: 1,
      });
      this.exist_item = null;
      this.exist_dialog = false;
    },
    remove_item(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
      for (const index in this.items) {
        this.items[index].number = +index + 1;
      }
    },
    async update() {
      const suppliers = this.$communicator.then(
        this,
        await this.$communicator("all_suppliers")
      );
      if (suppliers) this.suppliers = suppliers;
      if (this.target == "update") {
        const purchase = this.$communicator.then(
          this,
          await this.$communicator("purchase", {
            arguments: [this.$route.query["id"]],
          })
        );
        for (let i = 0; i < purchase.additional_cost.length; i++) {
          purchase.additional_cost[i].index = i + 1;
        }
        this.$refs["purchase"].init(purchase);
        for (const ind in purchase.items) {
          purchase.items[ind].number = +ind + 1;
        }
        this.items = this.$copy(purchase.items);
        if (purchase.status != "closed") {
          this.itemsRefresh();
        }
        this.params.supplier_id = purchase.supplier_id;
        this.params.send_message_to_supplier =
          purchase.send_message_to_supplier;
        this.params.service = purchase.service;
        this.params.purchase_order_date = new Date(purchase.purchase_order_date)
          .toISOString()
          .substr(0, 10);
        if (purchase.expected_on) {
          this.params.expected_on = new Date(purchase.expected_on)
            .toISOString()
            .substr(0, 10);
        }
      }
      this.getPurchaseItems();
    },
    async getPurchaseItems(search, service_changed = false) {
      if (typeof search != typeof "invan") {
        search = "";
      }
      if (search == this.search_text && !service_changed && search != "123") {
        return;
      }
      this.search_text = search + "";
      const items = this.$communicator.then(
        this,
        await this.$communicator("get_items_for_purchase", {
          arguments: [20, 1],
          params: {
            service: this.params.service,
            search: search,
          },
        })
      );
      if (items.length == 0) {
        this.create_new_item = true;
      }
      if (items) {
        var items_list = [];
        for (const index in items) {
          let search_text =
            items[index].name +
            this.converter(items[index].name) +
            items[index].sku;
          if (
            items[index].barcode &&
            typeof items[index].barcode == typeof []
          ) {
            for (const b of items[index].barcode) {
              search_text += b;
            }
          }
          items_list.push({
            product_id: items[index]._id,
            amount: items[index].price,
            product_name: items[index].name,
            purchase_cost:
              typeof items[index].purchase_cost != typeof 5 ||
              !items[index].purchase_cost
                ? 0
                : items[index].purchase_cost,
            search_text: search_text,
            quality: items[index].quality,
            // mxik:items[index].mxik,
            // nds_value:items[index].nds_value,
            sku: items[index].sku,
            barcode: items[index].barcode,
            in_stock: items[index].in_stock,
            incoming: items[index].incoming,
            purchase_cost_currency: items[index].purchase_cost_currency,
          });
        }
        this.items_list = items_list;
      }
    },
    async itemsRefresh() {
      const item_ids = [];
      for (const it of this.items) {
        item_ids.push(it.product_id);
      }
      const response = this.$communicator.then(
        this,
        await this.$communicator("get_items_for_purchase_refresh", {
          params: {
            indexes: item_ids,
            service: this.params.service,
          },
        })
      );
      if (response instanceof Array) {
        const itemMap = {};
        for (const it of response) {
          itemMap[it._id] = it;
        }
        for (const ind in this.items) {
          this.items[ind].number = +ind + 1;
          if (itemMap[this.items[ind].product_id]) {
            this.items[ind].incoming =
              itemMap[this.items[ind].product_id].incoming;
            this.items[ind].in_stock =
              itemMap[this.items[ind].product_id].in_stock;
          }
        }
      }
    },
    async save(status = "pending") {
      this.saving_document = true;
      if (typeof status != typeof "invan") {
        status = "pending";
      }
      const params = this.$copy(
        Object.assign(this.params, this.$refs["purchase"].options())
      );
      params.purchase_order_date = new Date(
        params.purchase_order_date
      ).getTime();
      if (params.expected_on) {
        params.expected_on = new Date(params.expected_on).getTime();
      }
      const items = [];
      for (const index in this.items) {
        items.push({
          product_id: this.items[index].product_id,
          cost: this.items[index].cost,
          product_name: this.items[index].product_name,
          purchase_cost: this.items[index].purchase_cost,
          purchase_cost_currency: this.items[index].purchase_cost_currency,
          quality: this.items[index].quality,
          sku: this.items[index].sku,
          // mxik: this.items[index].mxik,
          // nds_value: this.items[index].nds_value,
        });
      }
      params.items = items;
      if (this.target == "create" && this.purchase_type == "upload_file") {
        const formData = new FormData();
        formData.append("file", this.items_file);
        formData.append("supplier_contract", this.params.supplier_contract);
        formData.append("service", params.service);
        formData.append("supplier_id", params.supplier_id);
        formData.append("purchase_order_date", params.purchase_order_date);
        formData.append("expected_on", params.expected_on);
        formData.append("notes", params.notes);
        formData.append("partiation_no", params.partiation_no);
        formData.append("status", status);
        const res = await this.$communicator.uploadFile(
          "inventory/upload-purchase-items",
          formData
        );
        if (
          res &&
          res.data &&
          res.data.statusCode == 200 &&
          res.data.data.type != "error"
        ) {
          this.$router.push({
            path: "/inventory/purchase/view",
            query: {
              id: res.data.data._id,
            },
          });
        } else if (
          res &&
          res.data &&
          res.data.statusCode == 200 &&
          res.data.data.type == "error"
        ) {
          this.error = true;
          this.upload_errors = res.data.data.errors;
        } else {
          this.error = true;
          this.upload_errors = [{ place: "Error on upload" }];
        }
        this.saving_document = false;
        return;
      } else if (
        this.target == "create" &&
        this.purchase_type == "by_receipt"
      ) {
        const receipts = [];
        for (const r of this.receipts) {
          receipts.push(r._id);
        }
        const response = this.$communicator.then(
          this,
          await this.$communicator("create_purchase_by_receipt", {
            params: {
              ...params,
              status: status,
              receipts: receipts,
            },
          })
        );
        if (response) {
          this.$router.push({
            path: "/inventory/purchase/view",
            query: {
              id: response._id,
            },
          });
        }
      } else {
        if (this.target === "create") {
          let link = "create_purchase";
          if (this.params.type === "refund") {
            link = "create_purchase_refund";
          }
          params.status = status;
          // } else if ( this.params.refund === "refund"){
          //   let link2
          // }
          // if (link === "create_purchase_refund") {
          //   params.status = status;
          // }
          // if (link == "create_purchase") {
          //   params.status = status;
          // }
          const response = this.$communicator.then(
            this,
            await this.$communicator(link, {
              params: params,
            })
          );
          if (response) {
            this.$toast.success("Success", { timeout: 2000 });
            this.$router.push({
              path: "/inventory/purchase/view",
              query: {
                id: response._id,
              },
            });
          }
        } else {
          await this.$communicator("update_purchase", {
            arguments: [this.$route.query["id"]],
            params: params,
          });
          this.$router.push({
            path: "/inventory/purchase/view",
            query: this.$route.query,
          });
        }
      }
      this.saving_document = false;
    },
    cancel() {
      if (this.target == "create") {
        // this.$router.push({ path: "/inventory/purchase" });
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "/inventory/purchase/view",
          query: this.$route.query,
        });
      }
    },
    async addBySupplier(ind) {
      const items = this.$communicator.then(
        this,
        await this.$communicator("get_items_for_purchase", {
          params: {
            service: this.params.service,
            supplier: this.params.supplier_id,
            state: ind == 2 ? "low" : "all",
          },
        })
      );
      const existItems = {};
      for (const itm of this.items) {
        existItems[itm.product_id] = itm;
      }
      for (const item of items) {
        if (existItems[item._id] == undefined) {
          this.items.push({
            ...item,
            product_id: item._id,
            product_name: item.name,
            number: this.items.length + 1,
          });
        }
      }
    },
    searchTechMaps(search) {
      if (typeof search !== "string") {
        search = "";
      }
      if (this.tech_map_search == search) {
        return;
      }
      this.tech_map_search = search;
      this.getTechMap(search);
    },
    validateSupplierContract(value) {
      return this.supplierContracts.length > 0 && this.supplierContracts[0].value !== null ? value !== null : true
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
  mounted() {
    window.addEventListener(
      "offline",
      () => (
        this.$toast.error("Offline", { timeout: 2000 }),
        (this.saving_document = false),
        (this.isoffline = true)
      )
    );
    window.addEventListener(
      "online",
      () => (
        this.$toast.success("Online", { timeout: 2000 }),
        (this.saving_document = false),
        (this.isoffline = false)
      )
    );
    this.update();
  },
};
</script>
